import { Swiper, SwiperSlide } from 'swiper/react'
import SwiperCore, { Navigation, A11y, Pagination, Mousewheel } from 'swiper'
import classNames from 'classnames'
import { MatchingFundHelper, GtmHelper, formatCents, findApiV4Link, gaEvent, useJsonApi } from 'shared'

SwiperCore.use([Navigation, A11y, Pagination, Mousewheel])

export const NeedList = ({ apiUrl, projectApiUrl }) => {
  const { data: needs } = useJsonApi(apiUrl)
  const { data: project } = useJsonApi(projectApiUrl)
  if (!needs || !project) return null

  const count = needs.total_entries
  const btnGroupClass = count < 4 ? ' desktop:hidden' : ' desktop:block'

  return <div>
    <h2 className='text-3xl'>
      {I18n.t('projects.show.needs.headline')} ({count})
        <div className={'btn-group btn-group-with-small-arrows hidden' + btnGroupClass}>
        <a id='need-list-prev' className='btn btn-secondary'>
          <i className='fa fa-caret-left'></i>
        </a>
        <a id='need-list-next' className='btn btn-secondary'>
          <i className='fa fa-caret-right'></i>
        </a>
      </div>
    </h2>
    <Swiper
      spaceBetween={40}
      slidesPerView={1}
      pagination={count > 1 ? {
        clickable: true,
        dynamicBullets: true,
      } : false}
      navigation={{
        nextEl: '#need-list-next',
        prevEl: '#need-list-prev',
        disabledClass: 'is-disabled',
      }}
      centeredSlides={count == 1}
      roundLengths
      mousewheel={{ forceToAxis: true }}
      breakpoints={{
        450: {
          slidesPerView: 3,
        },
      }}
    >
      {needs.data.map(need => <SwiperSlide key={need.id}>
        <Need project={project} need={need} />
      </SwiperSlide>)}
    </Swiper>
  </div>
}

const Need = ({ project, need }) => {
  let donateUrl
  if (!project.donations_prohibited) {
    donateUrl = findApiV4Link({ ofObject: need, withRel: 'new_donation' })
  }

  const hasMatchingFund = !!MatchingFundHelper.locallyActiveMatchingFund(project)

  const tracking = (event) => {
    project && GtmHelper.pushAddToBasket(project)

    if (event.target.classList.contains('btn')) {
      gaEvent('donation', 'click need_donation_button', need.title)
    } else {
      gaEvent('donation', 'click need_donation_container', need.title)
    }
  }

  const teaserClass = classNames('need-teaser', 'swiper-slide', {
    'need-teaser-disabled': project && project.donations_prohibited,
  })

  return <a href={donateUrl} className={teaserClass} onClick={tracking}>
    <div className='text-lg' dangerouslySetInnerHTML={{ __html: need.title }}></div>
    <div className='need-teaser-amount'>
      {formatCents(need.open_amount_in_cents, { precision: 0 })}&nbsp;
      {I18n.t('projects.show.needs.still_missing_label')}&nbsp;
      {formatCents(need.requested_amount_in_cents, { precision: 0 })}
    </div>
    <div className='need-teaser-description' dangerouslySetInnerHTML={{ __html: need.description }}></div>
    <DonateButton duplicationIcon={hasMatchingFund} />
    <div className='progress generic-progress-bar'>
      <div className='bar' style={{ width: `${need.progress_percentage}%` }}></div>
    </div>
  </a>
}

const DonateButton = ({ duplicationIcon }) => {
  const btnClass = classNames('btn', 'btn-primary', 'btn-large',
    'no-pseudo-hover-styles', { 'duplication-icon': duplicationIcon })

  return <span className={btnClass}>{I18n.t('projects.show.needs.donate_button_label')}</span>
}
